module.exports = __webpack_public_path__ + "static/media/underdogs-2-wabi-sabi.d97d9e83.jpg";